import { tx, onEvent, LOCALE_CHANGED } from '@transifex/native';

/* supported locales */
export type TLocales = 'en' | 'da';

tx.init({
  token: import.meta.env.REACT_APP_TRANSIFEX_TOKEN,
});

// Keep <html lang> in sync with the active locale. index.html ships lang="en"
// and never updated it, so CSS hyphenation (`hyphens: auto`) and screen readers
// treated Danish/Finnish/etc. content as English. Every locale switch (the
// tenant default at boot, the language pickers, the browserless calendars)
// routes through tx.setCurrentLocale and fires LOCALE_CHANGED, so this one
// global listener covers the whole app — no per-component lang patching needed.
onEvent(LOCALE_CHANGED, () => {
  const locale = tx.getCurrentLocale();
  if (locale) {
    document.documentElement.lang = locale.toLowerCase().split(/[-_]/)[0];
  }
});
